/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { User } from '@modules/cloud-api/v1/types'

import { ThunkDispatch } from '@/types/redux'
import { createUserRequest } from '@/reducers/asyncRequests/registry'

import { createNativeUser } from '../../../../../../actions/localUsers'
import UserFlyout from '../UserFlyout'

const mapStateToProps = (state, { regionId }) => ({
  onSaveRequestState: createUserRequest(state, regionId),
})

const mapDispatchToProps = (dispatch: ThunkDispatch) => ({
  onSave: (user: User) => dispatch(createNativeUser(user)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UserFlyout)
